export default __webpack_public_path__ + "static/media/prev-not-clicked-green.55ce1219.svg";